import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserSettingsStore {
  isMuted: boolean;
  referralCode: string | null;
  setIsMuted: (mute: boolean) => void;
  setReferralCode: (referralCode: string) => void;
  clearReferralCode: () => void;
}

export const useUserSettingsStore = create<UserSettingsStore>()(
  persist(
    (set) => ({
      isMuted: true,
      referralCode: null,
      setIsMuted: (mute) => set((state) => ({ ...state, isMuted: mute })),
      setReferralCode: (referralCode) =>
        set((state) => ({ ...state, referralCode: referralCode })),
      clearReferralCode: () =>
        set((state) => ({ ...state, referralCode: null })),
    }),
    {
      name: 'user-settings-storage',
    },
  ),
);
